module.exports = __webpack_public_path__ + "static/media/best-localized.8ee61383.png";